import React from 'react';
import styles from './loader.module.scss';

interface ILoader {
  isWhite?: boolean;
  small?: boolean;
  color?: string;
}

const Loader = ({ isWhite = false, small = false, color } : ILoader) => (
  <div
    className={`${styles.loader}${isWhite ? ` ${styles.white}` : ''}${small ? ` ${styles.small}` : ''}`}
  >
    <div style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined} />
    <div style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined} />
    <div style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined} />
    <div style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined} />
  </div>
);

export default Loader;
